var _defs, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconeIfa(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37.249,
    height: 37.221,
    viewBox: "0 0 37.249 37.221",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n            .icone-ifa-a{fill:#8dbc29}.icone-ifa-b{fill:#c7bc1e}\r\n        "))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1163.298 -95.066)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "icone-ifa-a",
    d: "M1262.328,190.8c-3.665,3.634-12.938,7.644-15.023,5.578s1.962-11.257,5.628-14.891,7.864-2.615,9.949-.548S1265.993,187.174,1262.328,190.8Z",
    transform: "translate(-64.219 -64.66)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "icone-ifa-a",
    d: "M1165.734,190.8c3.666,3.634,12.939,7.644,15.024,5.578s-1.961-11.257-5.628-14.891-7.865-2.615-9.95-.548S1162.069,187.174,1165.734,190.8Z",
    transform: "translate(0 -64.66)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "icone-ifa-b",
    d: "M1257.784,140.424c-2.749,2.724-9.7,5.733-11.268,4.182s1.472-8.444,4.221-11.167,5.9-1.962,7.463-.412S1260.533,137.7,1257.784,140.424Z",
    transform: "translate(-63.721 -28.14)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "icone-ifa-b",
    d: "M1185.339,140.424c2.748,2.724,9.7,5.733,11.268,4.182s-1.472-8.444-4.221-11.167-5.9-1.962-7.462-.412S1182.59,137.7,1185.339,140.424Z",
    transform: "translate(-15.557 -28.14)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1254.377,101.662c-2.062,2.044-7.279,4.3-8.452,3.138s1.1-6.333,3.166-8.376a3.867,3.867,0,0,1,5.6-.309A3.786,3.786,0,0,1,1254.377,101.662Z",
    transform: "translate(-63.348)",
    style: {
      fill: "#ec8111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1200.041,101.662c2.061,2.044,7.278,4.3,8.451,3.138s-1.1-6.333-3.166-8.376a3.868,3.868,0,0,0-5.6-.309A3.785,3.785,0,0,0,1200.041,101.662Z",
    transform: "translate(-27.225)",
    style: {
      fill: "#e88315"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconeIfa);
export default __webpack_public_path__ + "static/media/icone-ifa.0764c9e8.svg";
export { ForwardRef as ReactComponent };